import { render, staticRenderFns } from "./AddInvoiceItems.vue?vue&type=template&id=b853bfd4&scoped=true"
import script from "./AddInvoiceItems.vue?vue&type=script&lang=js"
export * from "./AddInvoiceItems.vue?vue&type=script&lang=js"
import style0 from "./AddInvoiceItems.vue?vue&type=style&index=0&id=b853bfd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b853bfd4",
  null
  
)

export default component.exports